import _ from 'lodash'

export const NAMESPACE = 'KanBo/cardRelations/'
export const ADD_CARD_RELATION = NAMESPACE + 'ADD_CARD_RELATION'
export const ADD_CARD_RELATIONS = NAMESPACE + 'ADD_CARD_RELATIONS'
export const REMOVE_CARD_RELATION = NAMESPACE + 'REMOVE_CARD_RELATION'
export const SET_CARD_RELATION = NAMESPACE + 'SET_CARD_RELATION'

const initialState = {
  byId: {}
}

const cardRelationDefaults = {
  defaultParentId: null,
  parentIds: [],
  childIds: [],
  predecessorIds: [],
  successorIds: []
}

function uniqueConcat (array1, array2) {
  if (!array2) return array1

  return _.uniq(array1.concat(array2))
}

function removeByArray (array1, array2) {
  if (!array2) return array1

  return _.difference(array1, array2)
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD_CARD_RELATION:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            parentIds: uniqueConcat(state.byId[action.payload.id].parentIds, action.payload.parentIds),
            childIds: uniqueConcat(state.byId[action.payload.id].childIds, action.payload.childIds),
            predecessorIds: uniqueConcat(state.byId[action.payload.id].predecessorIds, action.payload.predecessorIds),
            successorIds: uniqueConcat(state.byId[action.payload.id].successorIds, action.payload.successorIds),
          }
        }
      } : {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...cardRelationDefaults,
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      }
    case ADD_CARD_RELATIONS: {
      if (action.payload.relations && action.payload.relations.length) {
        const newState = {
          ...state,
          byId: { ...state.byId }
        }

        action.payload.relations.forEach(relation => {
          if (newState.byId[relation.id]) {
            newState.byId[relation.id] = {
              ...newState.byId[relation.id],
              parentIds: uniqueConcat(newState.byId[relation.id].parentIds, action.payload.parentIds),
              childIds: uniqueConcat(newState.byId[relation.id].childIds, action.payload.childIds),
              predecessorIds: uniqueConcat(newState.byId[relation.id].predecessorIds, action.payload.predecessorIds),
              successorIds: uniqueConcat(newState.byId[relation.id].successorIds, action.payload.successorIds),
            }
          } else {
            newState.byId[relation.id] = {
              ...cardRelationDefaults,
              ...newState.byId[relation.id],
              ...relation
            }
          }
        })

        return newState
      }

      return state
    }
    case REMOVE_CARD_RELATION:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            parentIds: removeByArray(state.byId[action.payload.id].parentIds, action.payload.parentIds),
            childIds: removeByArray(state.byId[action.payload.id].childIds, action.payload.childIds),
            predecessorIds: removeByArray(state.byId[action.payload.id].predecessorIds, action.payload.predecessorIds),
            successorIds: removeByArray(state.byId[action.payload.id].successorIds, action.payload.successorIds),
          }
        }
      } : state
    case SET_CARD_RELATION:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...cardRelationDefaults,
            ...state.byId[action.payload.id],
            ...action.payload.data
          }
        }
      } : state
    default: return state
  }
}

export function addCardRelation (data) {
  return {
    type: ADD_CARD_RELATION,
    payload: data
  }
}

export function addCardRelations (relations) {
  return {
    type: ADD_CARD_RELATIONS,
    payload: {
      relations
    }
  }
}

export function removeCardRelation (data) {
  return {
    type: REMOVE_CARD_RELATION,
    payload: data
  }
}

export function setCardRelation ({ id, ...data }) {
  return {
    type: SET_CARD_RELATION,
    payload: {
      id,
      data
    }
  }
}
